import { useDispatch, useSelector } from "react-redux";
import { useEffect } from "react";
import { useParams, Link } from "react-router-dom";
import { getInDocumentId } from "../../redux/actions/actioninDocument";
import { getDocuments } from "../../redux/actions/actionDocument";
import { format } from "date-fns"

export default function InDocumentId() {
    
    const dispatch = useDispatch();
    const { id } = useParams();
    const documentId = useSelector(state => state.inDocuments.inDocumentDetail);
    const documents = useSelector(state => state.documents.allDocuments)   
    
    useEffect( () => {
        dispatch(getInDocumentId(id));
        dispatch(getDocuments())
    }, [dispatch, id])

    console.log(documentId)
    console.log(documents);
    const auxDate = new Date(documentId.createdAt)
    console.log(auxDate)
    
    return (
        <div className="container bg-gray-900">
            <div className="container m-8 text-orange-500 text-[10pt] font-bold">
            <div>
                <p className="text-xl pb-8 underline">Remitos Entrada - Detalle</p>
            </div>
                <div className="flex w-3/3 mt-6 border-b-2 border-slate-500 pb-2">
                    <p className="w-1/3">Documento N°: {documentId.numberDocument}</p>
                    {documentId.length === 0 ? (<p className="w-1/3">Fecha:</p>) :  (<p className="w-1/3">Fecha: {format(new Date(documentId.createdAt), "dd/MM/yyyy")}</p>)}
                </div>
                <div className="">
                    {documentId.client_id === undefined ? (
                <div className="w-full py-2 pb-2 border-b-2 border-slate-500">
                <div className="flex">
                        <p className="w-1/4">Cliente N°:</p>
                        <p className="w-1/4">Compañia:</p>
                        <p className="w-1/4">Nombre:</p>
                        <p className="w-1/4">Apellido:</p>
                </div>
                <div className="flex">
                        <p className="w-1/4">Dirección:</p>
                        <p className="w-1/4">Ciudad:</p>
                        <p className="w-1/4">Telefonos:</p>
                        <p className="w-1/4">E-mail:</p>
                        </div>
                </div>
                        
                    ) : (
                        <div className="w-full py-2 pb-2 border-b-2 border-slate-500">
                            <div className="flex">
                        <p className="w-1/4">Cliente N°: {documentId.client_id.idClient}</p>
                        <p className="w-1/4">Compañia: {documentId.client_id.nameCompany}</p>
                        <p className="w-1/4">Nombre: {documentId.client_id.name}</p>
                        <p className="w-1/4">Apellido: {documentId.client_id.lastName}</p>
                        </div>
                        <div className="flex">
                        <p className="w-1/4">Dirección: {documentId.client_id.address}</p>
                        <p className="w-1/4">Ciudad: {documentId.client_id.city}</p>
                        <p className="w-1/4">Telefonos: {documentId.client_id.telephoneNumber}</p>
                        <p className="w-1/4">E-mail: {documentId.client_id.email}</p>
                        </div>
                        </div>
                    )}
                </div>
                <div className="flex w-3/3 border-b-2 border-slate-500 py-2">
                    <p className="w-1/3">Dirección de Evento: {documentId.addressEvent}</p>
                    <p className="w-1/3">Fecha de Recepción: {documentId.dateReception ? format(new Date(documentId.dateReception), "dd/MM/yyyy") : null}</p>
                </div>
                <div className="pt-4">
                    <p className="font-bold text-[12pt]">Artículos:</p>
                </div>
                <div className="">
                <div className="mb-2">
                {/* <div>
                    <p className="flex font-bold pb-2">Documento Referenciado: <Link to={`/documentos/${documentId.document_id._id}`}><p className="ml-2">{documentId && documentId.document_id.numberDocument}</p></Link></p> 
                </div> */}
                <div className="flex mb-2">
                    <p className="w-1/3">Nombre</p>
                    <p className="w-2/5">Descripción</p>
                    <p className="w-20 text-center">Cantidad</p>
                </div>
                <div className="">
                {documentId.document_id && documentId.document_id.quantityItems.map(e=> {
                        return (
                            <div className="flex border-b-2 border-slate-500 text-[9pt]" key={e.item}>
                            <p className="w-1/3">{e.name}</p>
                            <p className="w-2/5">{e.descrip}</p>
                            <p className="w-20 text-center">{e.quantity}</p>
                            </div>
                        )
                    })
                    }
                </div>
                </div>

                <div className="mb-2 mt-8 border-t-2 border-green-500">
                <div>
                    <p className="font-bold pb-2">Ingresados</p>
                </div>
                <div className="flex mb-2">
                    <p className="w-1/3">Nombre</p>
                    <p className="w-2/5">Descripción</p>
                    <p className="w-20 text-center">Cantidad</p>
                </div>
                <div className="">
                {documentId.document_id && documentId.quantityItems.map(e=> {
                        return (
                            <div className="flex border-b-2 border-slate-500 text-[9pt]" key={e.item}>
                            <p className="w-1/3">{e.name}</p>
                            <p className="w-2/5">{e.descrip}</p>
                            <p className="w-20 text-center">{e.quantity}</p>
                            </div>
                        )
                    })
                    }
                </div>
                </div>              

                </div>
            </div>
        </div>
    )
}
